import { useContext } from 'react';
import { PdfContext } from 'utils/context';
import '../pdfComponent.style.scss';
import './grossMarginGraph.style.scss';

/**
 * Affiche une image PNG (graphique stacked ou line chart) dans une page PDF.
 *
 * @param {string} img
 * @param {string} title
 */
const GenericGraphPage = ({ img, title }) => {
  if (!img) return null;

  return (
    <article className="pdf-page">
      <div className="marge_brute_graph tableau_center">
        {title && <h6 className="title_h6">{title}</h6>}
        <img src={img} alt={title ?? 'Graphique'} />
      </div>
    </article>
  );
};
export default GenericGraphPage;
